import register from '@kpsys/angularjs-register';
import exemplarStatusesRoutes from './exemplar-statuses.routes';
import {ExemplarStatusDataService} from './exemplar-status.data-service';

export default register('exemplar-statuses')
    .config(exemplarStatusesRoutes)
    .service(ExemplarStatusDataService.serviceName, ExemplarStatusDataService)
    .name();